//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import moment from 'moment'
import axios from 'axios'
import Form from 'vform'

export default {
    layout: 'default',
    // middleware: 'guest',

    data(){ return {
        form: {
            id: '',
            expires: '',
            signature: ''
        },

        user: null,

        status: 'Verifying',
        code: 1,
        url: '',
        submitting: true,
        response: null
    }},

    filters: {
        getDate(val){
            return moment(val).format('DD.MM.YYYY')
        }
    },

    computed: {

    },

    mounted(){
        this.load()
        this.verify()
    },

    methods: {
        load(){
            if(this.$route.params.id)
              this.form.id = this.$route.params.id

            if(this.$route.query.expires)
              this.form.expires = this.$route.query.expires

            if(this.$route.query.signature)
              this.form.signature = this.$route.query.signature
        },

        getVerifyUrl(){
            return '/api/auth' + this.$route.fullPath

            let url = this.url = '/api/auth/email/verify/' + this.form.id + '?' + this.$util.buildURLQuery(this.form)
            return url
        },

        verify(){
            if(!this.form.id || !this.form.expires || !this.form.signature){
                this.$router.push({ name: 'about' })
                return
            }

            axios.post(this.getVerifyUrl())
                 .then( r => {
                      this.status = r.data.status
                      return r
                 })
                 .catch( e => {
                      console.log(e.response)
                      let r = e.response
                      this.code = 0
                      this.status = r.data.status
                      return r
                 })
                 .then( r => {
                      this.welcome(r)
                      this.stop()
                  })
        },

        welcome(r){
            if(r.data.user)
              this.user = r.data.user

            if(r.data.token){
                this.$store.dispatch('auth/saveToken', { token: r.data.token })
                this.$store.dispatch('auth/fetchUser')
                this.response = r.data.user
            }
        },

        stop(){
            this.submitting = false
        }


    }
}
